<!-- svelte-ignore a11y-missing-attribute -->
<nav class="navbar">
  <div class="container custom-navbar-container">
    <div class="navbar-brand">
      <a class="navbar-item" rel=prefetch href="https://agoodthing.org.uk">
        <img src="/assets/img/a_good_thing_logo.png" style="max-height:41px" />
      </a>
    </div>
    <div class="navbar-menu">
      <div class="navbar-start" />
      <div class="navbar-end">
        <div class="navbar-item has-text-grey-light">
          <span>We are a not-for-profit organisation matchmaking
            <br />businesses who care with amazing local charities.</span>
        </div>
        <div class="navbar-item">
          <a href="{$appState.origin}/{loginPath}" class="button is-secondary">Log in</a>
        </div>
        <div class="navbar-item">
          <a href="{$appState.origin}/signup" class="button is-primary">Sign up</a>
        </div>
      </div>
    </div>
  </div>
</nav>

<script lang="ts">
  import { appState } from "../../../lib/appState";
  import { params } from '@sveltech/routify';

  let loginPath =
    $params.id ? `charity/offer/${$params.id}` : 
    ($params.needid ? `business/need/${$params.needid}` : ''); 

</script>

<style>
  .custom-navbar-container {
    padding-top: 20px;
    padding-bottom: 20px;
  }
</style>
